import React, { useState } from "react";
import { FaAddressBook } from "react-icons/fa";
import { BsFillJournalBookmarkFill } from "react-icons/bs";
const Assignment = () => {
    const [menuModel,setMenumodel] = useState('assignments')
  return (
    <div className="w-full flex flex-col gap-4">
      {/* item-1 */}
      <div className="w-full flex lg:flex-row flex-col gap-4 items-center">

        <div className="lg:w-1/2 w-full bg-[#00294B] p-4 rounded-md flex gap-4 items-center">
          <div className="w-[3rem] h-[3rem] bg-[#00CAFF] rounded-full flex justify-center items-center">
            <span>
              <FaAddressBook />
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-white text-xl font-bold">7</span>
            <span className="text-base text-green-200">Completed</span>
          </div>
        </div>

        <div className="lg:w-1/2 w-full bg-[#00294B] p-4 rounded-md flex gap-4 items-center">
          <div className="w-[3rem] h-[3rem] bg-[#00CAFF] rounded-full flex justify-center items-center">
            <span>
              <BsFillJournalBookmarkFill />
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-white text-xl font-bold">0</span>
            <span className="text-base text-green-200">Pending</span>
          </div>
        </div>

      </div>

      {/* item-2 */}
      <div className="w-full flex gap-4 items-center">

          <div className="w-full flex flex-col gap-4 bg-[#00294B] rounded-md pt-4 ">
            <h2 className="px-4 text-2xl font-bold text-white">My Assignment</h2>
            <div className='w-full flex items-center gap-4 border-b border-[#254635]'>
                <span className={`text-base font-medium px-4 pb-2  ${menuModel === "assignments" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}  cursor-pointer`} onClick={()=>setMenumodel('assignments')}>All Assignment</span>
                <span className={`text-base font-medium px-4 pb-2   ${menuModel === "submitted" ? "border-b-2 border-[#22BEFF] text-[#22BEFF]":"text-gray-300"}  cursor-pointer`} onClick={()=>setMenumodel('submitted')}>Submitted</span>
                

            </div>
            {/* <span className="border-b border-[#254635]"></span> */}

            <div className='flex flex-col gap-4 p-4 min-h-[20rem]'>
                <h4 className='text-xl font-semibold text-white text-center'>No Assignment Found</h4>
                {/* working */}
               
            </div>

        </div>

      </div>
    </div>
  );
};

export default Assignment;
